import styled from 'styled-components';

export const HeaderTitle = styled.h1`
    text-align: center;
    color: var(--jk-text);
    font-size: 28px;
    font-weight: bold;
    margin: 40px 0;
    
    @media(max-width: 768px) {
        font-size: 24px;
        margin: 20px 0;
    }
`;

export const ModeContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    padding: 40px 20px;
    min-height: 60vh;
    
    @media(max-width: 768px) {
        flex-direction: column;
        gap: 30px;
        padding: 20px;
    }
`;

export const ModeCard = styled.div`
    background: var(--white-color);
    border: 1px solid rgba(0,0,0,0.06);
    border-radius: 16px;
    padding: 30px;
    max-width: 400px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: var(--elev-1);
    
    &:hover {
        transform: translateY(-6px);
        box-shadow: var(--elev-2);
    }
    
    @media(max-width: 768px) {
        max-width: 100%;
        padding: 20px;
    }
`;

export const ModeImage = styled.img`
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 12px;
    margin-bottom: 20px;
    
    @media(max-width: 768px) {
        height: 150px;
    }
`;

export const ModeTitle = styled.h2`
    color: var(--jk-text);
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 10px;
    
    @media(max-width: 768px) {
        font-size: 20px;
    }
`;

export const ModeDescription = styled.p`
    color: var(--jk-text);
    font-size: 15px;
    line-height: 1.5;
    
    @media(max-width: 768px) {
        font-size: 14px;
    }
`; 